<script>
export default {
    name: "whatsapp-utm",
    mounted() {
        window.location.href = "https://wa.me/263785832033";
    },
    render() {
        return null;
    }
}
</script>

<template>

</template>

<style scoped>

</style>
